const genderSeries: any = [23,34,5]

export default genderSeries;